// @ts-nocheck
import { Card, CardBody } from '@components/card/card';
import { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
// import AddDepartment from './AddDepartment';
import OrganizationForm from './OrganizationForm';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import EditFormDepartments from './EditDepartments/EditFormDepartments';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
import AddDepartment from './AddDepartment';

const Departments = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [id, setId] = useState('');
  const [search, setSearch] = useState('');
  const [orgType, setOrgType] = useState(null);
  const { OrgTypeList } = useLookupOrgType();
  const { Organizations, loading, error } = useGetOrganizations();
  const { dataORGCLASS } = useLookupOrgClass();

  // console.log(dataORGCLASS);

  const filteredOrg = Organizations?.slice()
    ?.filter(emp => {
      const searchLowerCase = search.toLowerCase();
      return (
        emp.name2?.toLowerCase().includes(searchLowerCase) ||
        emp.name?.toLowerCase().toString().includes(searchLowerCase) ||
        emp.locationName?.toString().includes(searchLowerCase) ||
        emp.locationName2?.toString().includes(searchLowerCase)
      );
    })
    ?.filter(f => (orgType === null ? true : f.type === orgType));

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`

  const columns = [
    { title: t('Name'), key: 'Name', className: 'w-25' },
    { title: t('location'), key: 'location', className: 'w-25' },
    { title: t('Type'), key: 'Type', className: 'w-25' },
    // { title: t('GeneralLedger'), key: 'ledger', className: 'w-25' },
    { title: t('Classification'), key: 'Classification', className: 'w-25', sortable: false },
    { title: t(''), key: 'action', className: 'text-end w-25', sortable: false }
  ];

  const tableData = filteredOrg?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      Type: OrgTypeList?.find(f => f.value === item.type)?.label,
      ledger: i18n.language === 'en' ? item.ledgerName : item.ledgerName2,
      // Classification: item.organizationInformation ? (
      //   <ul className="list-unstyled mb-0 p-0 d-flex flex-wrap gap-1">
      //     {item?.organizationInformation?.split(',')?.map((info, idx) => (
      //       <li
      //         key={idx}
      //         className="badge border border-theme text-theme px-2 pt-5px pb-5px rounded fs-12px me-1">
      //         {dataORGCLASS?.find((f) => f.value === info)?.label || ''}
      //       </li>
      //     ))}
      //   </ul>
      // ) : (
      //   <span className="text-muted"> </span>
      // ),
      Classification: item.organizationInformation ? (
        <ul className='list-unstyled mb-0 p-0 d-flex flex-wrap gap-1'>
          {item?.organizationInformation?.split(',')?.map((info, idx) => {
            // تحقق مما إذا كانت القيمة "OPERATING_UNIT"
            const isOperatingUnit = info === 'OPERATING_UNIT';
            return (
              <li
                key={idx}
                className={`badge border px-2 pt-5px pb-5px rounded fs-12px me-1 
                  ${isOperatingUnit ? 'bg-theme bg-opacity-60 fw-bold border-dark' : 'border-theme text-theme'}`}
              >
                {dataORGCLASS?.find(f => f.value === info)?.label || ''}
              </li>
            );
          })}
        </ul>
      ) : (
        <span className='text-muted'> </span>
      ),
      action: (
        <>
          {HasPermission('EditHrDepartments') && (
            <button
              type='button'
              className='btn btn-sm btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#Update'
              onClick={() => setId(item.id)}
            >
              <i className='far fa-lg fa-fw  fa-edit mx-1'></i>
              {t('Button.Edit')}
            </button>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`

 
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'Organization',
              link: null
            }
          ]}
          PageName='Organization'
        />
        <div className='ms-auto'>
          {HasPermission('AddHrDepartments') && (
            <Link
              to=''
              className='btn btn-outline-theme me-1'
              data-bs-toggle='modal'
              data-bs-target='#modalXl'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw '></i> {t('AddDepartment')}
            </Link>
          )}
        </div>
      </div> 

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row mb-3'>
              <div className='col-lg-3'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text text-theme fw-bold'>{t('Type')}</span>

                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    // isLoading={loading3}
                    isSearchable={true}
                    isClearable
                    // options={OrgTypeList?.filter(f => Organizations?.map(m => m.type)?.includes(f.value))}
                    options={OrgTypeList?.filter(f => Organizations?.some(m => m.type === f.value))}
                    onChange={option => {
                      setOrgType(option === null ? 'all' : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className='col-lg-5'></div>
              <div className='col-lg-4'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text  text-theme fw-bold'>
                    {t('Search')}
                    {/* <i className="fa fa-search  text-theme ms-3"></i> */}
                  </span>
                  <div className='input-group'>
                    <div className='flex-fill position-relative'>
                      <div className='input-group border-0 '>
                        <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                          <i className='fa fa-search opacity-5 text-theme'></i>
                        </div>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control ps-35px'
                          // placeholder={t('Search')}
                          value={search}
                          onChange={e => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
 
      <ModalComponent id='modalXl' title={t('AddDepartment')} size='lg'>
        {Show && <AddDepartment/>}
        {/* <OrganizationForm /> */}
      </ModalComponent>

      <ModalComponent id='Update' title={t('EditDepartment')} size='lg'>
        {id && <EditFormDepartments id={id} />}
      </ModalComponent>
    </>
  );
};

export default Departments;
